<template>
  <div class="border-bottom py-1">
    <div class="row">
      <div class="col-md-8">
        <label>
          {{data.name}}&nbsp;
          <span class="text-muted" v-html="numChars"></span>
        </label>
        <input
          class="form-control text-center my-1"
          type="text"
          v-model="documento.valor"
          :maxLength="(data.chars_num === 0) ? 99 : data.chars_num"
        />
        <input
          ref="fileInput"
          accept="image/jpeg, application/pdf"
          class="d-none"
          type="file"
          name="doc"
          @change="selectFile($event)"
        />
      </div>
      <div class="col-md-4">
        <label>&nbsp;</label>
        <button
          class="btn p-2 btn-warning btn-gr float-right w-100"
          @click="$refs.fileInput.click()"
        >
          <i class="fa fa-file" aria-hidden="true"></i>
          &nbsp;{{$t('seleccionar')}}
        </button>
        <button
          v-if="documento.fileSelected !== null"
          class="btn p-2 btn-primary btn-gr float-right mt-0 w-100"
          @click="upload"
        >
          <i class="fa fa-file" aria-hidden="true"></i>
          &nbsp;{{ $t('enviar') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "inscripcions-dog-cocuments-comp",
  props: ["data"],
  data: () => ({
    documento: {
      docId: null,
      datos: null,
      valor: null,
      fileSelected: null
    }
  }),
  methods: {
    selectFile: function(event) {
      this.documento.fileSelected = event.target.files[0];
    },
    upload(e) {
      
      //this.setFileData(this.fileSelected, 10, this.documentType);
      e.preventDefault();
      //comprobamos que hayan datos en el input
      if (this.data.chars_num > 0 && this.documento.valor !== null) {
        if (this.documento.valor.length !== this.data.chars_num) {
          alert("debug: Se deben rellenar los datos pertinentes con el total de caracteres obligatorios");
        }
        return;
      } else if (this.documento.valor === null) {
        alert("debug: No se ha informado el campo");
        return;
      }
      console.log("llego aqui");
      let dataUpload = {
        file: this.fileSelected,
        dogId: this.dogId,
        docType: this.documentType
      };

      console.log(dataUpload);
      this.uploadFile(dataUpload);
    }
  },
  computed: {
    numChars() {
      if (this.data.chars_num > 0 && this.documento.valor !== null) {
        return (
          "(" +
          (this.data.chars_num - this.documento.valor.length) +
          " " +
          this.$t("caracteres") +
          ")"
        );
      } else if (this.data.chars_num > 0 && this.documento.valor === null) {
        return this.data.chars_num + " " + this.$t("caracteres");
      }
    }
  },
  mounted() {
    this.documento.docId = this.data.id;
    this.documento.datos = this.data;
  }
};
</script>

<style scoped>
input {
  height:36px!important;
  color:black;
  font-size:22px;
}
</style>